<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0;">
            <div class="header-icon-wrap mr-3">
              <i class="fe fe-check-square" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">M&amp;E Manager</h4>
              <small style="opacity: 0.8;">Add and manage checklist items and categories</small>
            </div>
          </div>
        </div>
      </div>

      <section style="margin-top: -20px;">
        <div class="container pb-5">

          <!-- Tab bar -->
          <div class="card shadow-sm tab-card mb-4">
            <div class="card-body py-3 px-4">
              <div class="d-flex flex-wrap" style="gap: 8px;">
                <button type="button" class="btn btn-sm tab-btn"
                  :class="showadder ? 'active-tab' : 'btn-outline-secondary'" @click="openAddItemForm">
                  <i class="fe fe-plus mr-1"></i> Add Item
                </button>
                <button type="button" class="btn btn-sm tab-btn"
                  :class="showaddercat ? 'active-tab' : 'btn-outline-secondary'"
                  @click="showaddercat = !showaddercat">
                  <i class="fe fe-tag mr-1"></i> Add Category
                </button>
                <button type="button" class="btn btn-sm tab-btn btn-outline-secondary" @click="openCreateFormModal">
                  <i class="fe fe-file-plus mr-1"></i> Create New Form
                </button>
              </div>
            </div>
          </div>

          <!-- ── Create Form Modal ── -->
          <div v-if="showCreateFormModal" class="modal d-block" style="background: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content" style="border-radius: 12px; overflow: hidden;">
                <div class="form-card-header">
                  <div class="section-number"><i class="fe fe-file-plus" style="font-size: 12px;"></i></div>
                  <h6 class="mb-0 font-weight-bold text-white">Create New Form</h6>
                  <button type="button" class="close text-white ml-auto" style="opacity: .9;"
                    @click="showCreateFormModal = false">
                    <span>&times;</span>
                  </button>
                </div>
                <div class="modal-body px-4 py-4">
                  <div class="form-group">
                    <label class="small font-weight-bold text-secondary">Form Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" v-model="newForm.name" placeholder="Enter form name" />
                  </div>
                  <div class="form-group mb-0">
                    <label class="small font-weight-bold text-secondary">Description</label>
                    <textarea class="form-control" v-model="newForm.description" rows="3"
                      placeholder="Enter form description"></textarea>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-outline-secondary" @click="showCreateFormModal = false">
                    Close
                  </button>
                  <button type="button" class="btn btn-submit" @click="createForm">
                    <i class="fe fe-send mr-1"></i> Create Form
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- ── Add Item Form ── -->
          <div v-show="showadder" id="add-item-form" class="card shadow-sm form-card mb-4">
            <div class="form-card-header">
              <div class="section-number">
                <i class="fe fe-plus" style="font-size: 12px;"></i>
              </div>
              <h6 class="mb-0 font-weight-bold text-white">{{ editingItemId ? "Edit Item" : "Add Item" }}</h6>
              <span v-if="editingItemId" class="badge badge-warning ml-auto" style="border-radius:20px;font-size:.75rem;">Editing</span>
            </div>

                <div class="card-body px-4 py-4">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label class="small font-weight-bold text-secondary">Select Form <span class="text-danger">*</span></label>
                      <v-select v-model="item.form_id" label="name" :options="forms" />
                    </div>

                    <div class="form-group col-md-6">
                      <label class="small font-weight-bold text-secondary">Select Category <span class="text-danger">*</span></label>
                      <v-select v-model="item.quality_assurance_items_categories_id" label="category_name"
                        :options="categories" />
                    </div>

                    <div class="form-group col-md-12">
                      <label class="small font-weight-bold text-secondary">Item Name <span class="text-danger">*</span></label>
                      <textarea class="form-control" v-model="item.item_name" rows="3"></textarea>
                    </div>

                    <div class="form-group col-md-4">
                      <label class="small font-weight-bold text-secondary">Response Type <span class="text-danger">*</span></label>
                      <select class="form-control" v-model="item.response_type">
                        <option value="option">Option (dropdown)</option>
                        <option value="text">Text</option>
                        <option value="number">Number</option>
                        <option value="date">Date</option>
                      </select>
                    </div>

                    <div class="form-group col-md-4">
                      <label class="small font-weight-bold text-secondary">Item Order</label>
                      <input type="number" class="form-control" v-model.number="item.item_order" placeholder="0" />
                    </div>

                    <div class="form-group col-md-4 d-flex align-items-end">
                      <div>
                        <label class="checkbox-label d-block">
                          <input type="checkbox" v-model="item.is_scoring" /> Is Scoring Item
                        </label>
                        <label class="checkbox-label d-block mt-2" v-if="item.response_type === 'option'">
                          <input type="checkbox" v-model="item.is_multi_select" /> Allow Multi-Select
                        </label>
                      </div>
                    </div>

                    <div class="form-group col-md-6">
                      <label class="small font-weight-bold text-secondary">Depends on Item (Optional)</label>
                      <v-select v-model="item.depends_on_item_id" label="item_name" :options="otherItems"
                        @input="updateDependsOnOptions" />
                    </div>

                    <div class="form-group col-md-12">
                      <label class="small font-weight-bold text-secondary">Depends on Option (Only if depends on item is selected)</label>
                      <v-select v-model="item.depends_on_option_id" label="option_name" :options="dependsOnOptions"
                        :disabled="!item.depends_on_item_id" />
                    </div>
                  </div>

                  <!-- Options — only shown when response_type is 'option' -->
                  <div class="mb-3" v-if="item.response_type === 'option'">
                    <p class="small font-weight-bold text-secondary mb-2">
                      <i class="fe fe-list mr-1"></i> Response Options
                    </p>
                    <p v-if="!item.options.length" class="small text-muted mb-2">
                      This item has no options yet. Add the choices the facility can pick from.
                    </p>
                    <div v-for="(option, index) in item.options" :key="index"
                      class="p-3 rounded mb-2" style="background: #f8fafc; border: 1px solid #e9ecef;">
                      <div class="form-row align-items-end">
                        <div class="form-group col-md-3 mb-0">
                          <label class="small text-muted">Option Name</label>
                          <input type="text" class="form-control form-control-sm" v-model="option.option_name" />
                        </div>
                        <div class="form-group col-md-2 mb-0">
                          <label class="small text-muted">Score Value</label>
                          <input type="number" class="form-control form-control-sm" v-model.number="option.score_value" />
                        </div>
                        <div class="form-group col-md-4 mb-0">
                          <label class="checkbox-label small">
                            <input type="checkbox" v-model="option.has_custom_input" /> Has Custom Input
                          </label>
                        </div>
                        <div class="col-md-1 mb-0">
                          <button type="button" class="btn btn-sm btn-outline-danger w-100" @click="removeOption(index)" title="Remove option">
                            <i class="fe fe-trash-2"></i>
                          </button>
                        </div>

                        <div class="form-group col-md-5 mb-0 mt-2" v-if="option.has_custom_input">
                          <label class="small text-muted">Input Label</label>
                          <input type="text" class="form-control form-control-sm" v-model="option.custom_input_label"
                            placeholder="e.g., Specify..." />
                        </div>
                        <div class="form-group col-md-5 mb-0 mt-2" v-if="option.has_custom_input">
                          <label class="small text-muted">Placeholder</label>
                          <input type="text" class="form-control form-control-sm" v-model="option.custom_input_placeholder"
                            placeholder="e.g., Enter value" />
                        </div>
                      </div>
                    </div>
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="addOption">
                      <i class="fe fe-plus mr-1"></i> Add option
                    </button>
                  </div>
                  <div v-else class="alert alert-notice small mb-3">
                    <i class="fe fe-info mr-1"></i>
                    {{ responseTypeLabel(item.response_type) }} items are answered by typing, so they have no options.
                  </div>

                  <button type="button" class="btn btn-submit" @click="saveItem">
                    <i class="fe fe-send mr-1"></i> {{ editingItemId ? "Update Item" : "Submit Item" }}
                  </button>
                  <button v-if="editingItemId" type="button" class="btn btn-outline-secondary ml-2" @click="cancelEdit">
                    Cancel Edit
                  </button>
                </div>
          </div>

          <!-- ── Add Category Form ── -->
          <div v-show="showaddercat" class="card shadow-sm form-card mb-4">
            <div class="form-card-header">
              <div class="section-number">
                <i class="fe fe-tag" style="font-size: 12px;"></i>
              </div>
              <h6 class="mb-0 font-weight-bold text-white">Add Category</h6>
            </div>
            <div class="card-body px-4 py-4">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">Select Form <span class="text-danger">*</span></label>
                  <v-select v-model="category.form_id" label="name" :options="forms" />
                </div>

                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">Category Name <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" v-model="category.category_name" />
                </div>
              </div>
              <button type="button" class="btn btn-submit" @click="addCategory">
                <i class="fe fe-send mr-1"></i> Submit Category
              </button>
            </div>
          </div>

          <!-- ── Items Table Card ── -->
          <div class="card shadow-sm table-card">
            <div class="form-card-header">
              <div class="section-number">
                <i class="fe fe-list" style="font-size: 12px;"></i>
              </div>
              <h6 class="mb-0 font-weight-bold text-white">All Items</h6>
              <span v-if="allitems && allitems.length" class="badge badge-light ml-auto" style="border-radius:20px;">
                {{ allitems.length }}
              </span>
            </div>

            <div class="px-4 pt-3 pb-2 d-flex align-items-end" style="gap: 12px; background: #f8f9fa; border-bottom: 1px solid #f1f5f9;">
              <div class="form-group mb-0" style="min-width: 240px;">
                <label class="small font-weight-bold text-secondary">Filter by Form</label>
                <select class="form-control" v-model="filter.form_id">
                  <option value="">All Forms</option>
                  <option v-for="form in forms" v-bind:key="form.id" :value="form.id">
                    {{ form.name }}
                  </option>
                </select>
              </div>
              <button type="button" class="btn btn-sm btn-outline-primary mb-1" @click="allItems">
                <i class="fe fe-search mr-1"></i> Filter
              </button>
            </div>

            <div class="table-responsive">
              <table class="table align-td-middle mb-0">
                <thead style="background: #f8fafc;">
                  <tr>
                    <th class="table-th">Date</th>
                    <th class="table-th">Form</th>
                    <th class="table-th">Item Name</th>
                    <th class="table-th">Category</th>
                    <th class="table-th">Response Type</th>
                    <th class="table-th">Multi-Select</th>
                    <th class="table-th">Depends On</th>
                    <th class="table-th">Options</th>
                    <th class="table-th">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="diag in allitems" v-bind:key="diag.id" class="table-row">
                    <td class="px-4 py-3 text-muted small">{{ diag.created_at | formatDate }}</td>
                    <td class="py-3">
                      <span v-if="diag.form != null" style="font-size: 0.85rem;">{{ diag.form.name }}</span>
                      <span v-else class="text-muted">—</span>
                    </td>
                    <td class="py-3" style="max-width: 300px;">
                      <span style="font-size: 0.85rem;">{{ diag.item_name }}</span>
                    </td>
                    <td class="py-3">
                      <span v-if="diag.category != null" class="badge badge-soft-info" style="border-radius:20px;">
                        {{ diag.category.category_name }}
                      </span>
                    </td>
                    <td class="py-3">
                      <span class="type-chip" :class="'type-chip--' + responseType(diag)">
                        <i :class="responseTypeIcon(responseType(diag))"></i>
                        {{ responseTypeLabel(responseType(diag)) }}
                      </span>
                    </td>
                    <td class="py-3">
                      <span v-if="diag.is_multi_select" class="badge badge-success">Yes</span>
                      <span v-else class="badge badge-secondary">No</span>
                    </td>
                    <td class="py-3">
                      <small v-if="diag.depends_on_item_id">Item #{{ diag.depends_on_item_id }}</small>
                      <small v-else class="text-muted">—</small>
                    </td>
                    <td class="py-3">
                      <small v-if="responseType(diag) !== 'option' && !(diag.options || []).length" class="text-muted">—</small>
                      <small v-else-if="!(diag.options || []).length" class="text-warning font-weight-bold">No options yet</small>
                      <span v-else style="font-size: 0.85rem;">{{ diag.options.length }} options</span>
                    </td>
                    <td class="py-3">
                      <button type="button" class="btn btn-sm btn-outline-info mr-1" @click="startEditItem(diag)"
                        title="Edit">
                        <i class="fe fe-edit-2"></i>
                      </button>
                      <button type="button" class="btn btn-sm btn-outline-danger" @click="deleteItem(diag.id)"
                        title="Delete">
                        <i class="fe fe-trash-2"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="!allitems || !allitems.length">
                    <td colspan="9" class="text-center py-5 text-muted">
                      <i class="fe fe-inbox" style="font-size: 2rem; opacity: 0.3;"></i>
                      <p class="mt-2 mb-0">No items found — select a form and filter</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="vld-parent">
            <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";

  export default {
    name: "accreditation",
    components: {
      Navbar,
      Loading,
    },
    data() {
      return {
        user: null,
        forms: [],
        allitems: [],
        categories: [],
        sub_categories: [],
        services: [],
        showadder: false,
        showaddercat: false,
        showCreateFormModal: false,
        editingItemId: null,
        isLoading: false,
        fullPage: false,
        otherItems: [],
        dependsOnOptions: [],
        newForm: {
          name: "",
          description: "",
        },
        item: {
          item_name: "",
          form_id: "",
          response_type: "option",
          item_order: 0,
          is_scoring: false,
          is_multi_select: false,
          depends_on_item_id: null,
          depends_on_option_id: null,
          options: [
            {
              option_name: "",
              score_value: "",
              has_custom_input: false,
              custom_input_label: "",
              custom_input_placeholder: "",
            },
          ],
          quality_assurance_items_categories_id: "",
          quality_assurance_items_sub_categories_id: "",
        },
        filter: {
          form_id: "",
        },
        category: {
          form_id: "",
          category_name: "",
        },
        subcategory: {
          items_categories_id: "",
          sub_category_name: "",
        },
      };
    },
    methods: {
      openCreateFormModal() {
        this.newForm = { name: "", description: "" };
        this.showCreateFormModal = true;
      },
      createForm() {
        if (!this.newForm.name.trim()) {
          this.$toasted.error("Form name is required", {
            position: "top-center",
            duration: 3000,
          });
          return;
        }

        this.axios
          .post(`/api/v1/auth/forms`, {
            agency_id: "407465",
            name: this.newForm.name,
            description: this.newForm.description || "",
          })
          .then(() => {
            this.showCreateFormModal = false;
            this.newForm = { name: "", description: "" };
            this.getForms();
            this.$toasted.success("Form created successfully", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.error(error);
            this.$toasted.error("Failed to create form", {
              position: "top-center",
              duration: 3000,
            });
          });
      },
      openAddItemForm() {
        if (this.showadder) {
          this.showadder = false;
          return;
        }
        this.editingItemId = null;
        this.resetItemForm();
        this.updateOtherItems();
        this.showadder = true;
        this.scrollToItemForm();
      },
      startEditItem(item) {
        this.editingItemId = item.id;
        this.item = {
          ...item,
          form_id: this.forms.find((f) => f.id === item.form_id),
          quality_assurance_items_categories_id: this.categories.find(
            (c) => c.id === item.quality_assurance_items_categories_id
          ),
          is_scoring: !!item.is_scoring,
          is_multi_select: !!item.is_multi_select,
          depends_on_item_id: item.depends_on_item_id
            ? { id: item.depends_on_item_id, item_name: `Item #${item.depends_on_item_id}` }
            : null,
          response_type: item.response_type || "option",
          depends_on_option_id: item.depends_on_option_id ? { id: item.depends_on_option_id } : null,
          options: (item.options || []).map((opt) => ({
            ...opt,
            has_custom_input: !!opt.has_custom_input,
          })),
        };
        this.updateOtherItems();
        if (this.item.depends_on_item_id) {
          this.updateDependsOnOptions();
        }
        if (this.item.response_type === "option" && !this.item.options.length) {
          this.addOption();
        }
        this.showadder = true;
        this.scrollToItemForm();
      },
      cancelEdit() {
        this.editingItemId = null;
        this.resetItemForm();
        this.showadder = false;
      },
      scrollToItemForm() {
        this.$nextTick(() => {
          const el = document.getElementById("add-item-form");
          if (el && el.scrollIntoView) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        });
      },
      resetItemForm() {
        this.item = {
          item_name: "",
          form_id: "",
          response_type: "option",
          item_order: 0,
          is_scoring: false,
          is_multi_select: false,
          depends_on_item_id: null,
          depends_on_option_id: null,
          options: [
            {
              option_name: "",
              score_value: "",
              has_custom_input: false,
              custom_input_label: "",
              custom_input_placeholder: "",
            },
          ],
          quality_assurance_items_categories_id: "",
          quality_assurance_items_sub_categories_id: "",
        };
        this.dependsOnOptions = [];
      },
      saveItem() {
        if (!this.item.item_name.trim()) {
          this.$toasted.error("Item name is required", {
            position: "top-center",
            duration: 3000,
          });
          return;
        }
        if (!this.item.form_id) {
          this.$toasted.error("Please select a form", {
            position: "top-center",
            duration: 3000,
          });
          return;
        }
        if (this.item.response_type === "option") {
          this.item.options = this.item.options.filter((o) => o.option_name && String(o.option_name).trim());
          if (!this.item.options.length) {
            this.addOption();
            this.$toasted.error("Add at least one option for an option item", { position: "top-center", duration: 3000 });
            return;
          }
        }

        if (this.editingItemId) {
          this.updateItem();
        } else {
          this.addItem();
        }
      },
      updateOtherItems() {
        this.otherItems = this.allitems.filter(
          (item) => !this.editingItemId || item.id !== this.editingItemId
        );
      },
      updateDependsOnOptions() {
        if (!this.item.depends_on_item_id) {
          this.dependsOnOptions = [];
          this.item.depends_on_option_id = null;
          return;
        }

        const dependsOnItem = this.otherItems.find(
          (item) => item.id === this.item.depends_on_item_id.id
        );
        if (dependsOnItem && dependsOnItem.options) {
          this.dependsOnOptions = dependsOnItem.options;
        } else {
          this.dependsOnOptions = [];
        }
        this.item.depends_on_option_id = null;
      },
      addOption() {
        this.item.options.push({
          option_name: "",
          score_value: "",
          has_custom_input: false,
          custom_input_label: "",
          custom_input_placeholder: "",
        });
      },
      removeOption(index) {
        this.item.options.splice(index, 1);
      },
      // Items saved before response types existed have none; they work as option items.
      responseType(item) {
        return item.response_type || "option";
      },
      responseTypeLabel(type) {
        return { option: "Option", text: "Text", number: "Number", date: "Date" }[type] || type;
      },
      responseTypeIcon(type) {
        return { option: "fe fe-list", text: "fe fe-type", number: "fe fe-hash", date: "fe fe-calendar" }[type] || "fe fe-help-circle";
      },
      getSubCategories() {
        this.axios
          .get(`/api/v1/auth/qa-subcategories/407465`)
          .then((response) => {
            this.sub_categories = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getServices() {
        this.axios
          .get(`/api/v1/auth/qa-services/407465`)
          .then((response) => {
            this.services = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getForms() {
        this.axios
          .get(`/api/v1/auth/forms/407465`)
          .then((response) => {
            this.forms = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      addItem() {
        const payload = {
          agency_id: "407465",
          item_name: this.item.item_name,
          response_type: this.item.response_type,
          form_id: this.item.form_id.id,
          item_order: this.item.item_order || 0,
          is_scoring: this.item.is_scoring ? 1 : 0,
          is_multi_select: this.item.response_type === "option" ? (this.item.is_multi_select ? 1 : 0) : 0,
          depends_on_item_id: this.item.depends_on_item_id
            ? this.item.depends_on_item_id.id
            : null,
          depends_on_option_id: this.item.depends_on_option_id
            ? this.item.depends_on_option_id.id
            : null,
          quality_assurance_items_categories_id:
            this.item.quality_assurance_items_categories_id?.id,
          options: this.item.response_type === "option"
            ? this.item.options.map((opt) => ({
                option_name: opt.option_name,
                score_value: opt.score_value,
                has_custom_input: opt.has_custom_input ? 1 : 0,
                custom_input_label: opt.custom_input_label || null,
                custom_input_placeholder: opt.custom_input_placeholder || null,
              }))
            : [],
        };

        this.axios
          .post(`/api/v1/auth/qa-addItem`, payload)
          .then((response) => {
            this.allItems();
            this.resetItemForm();
            this.showadder = false;
            console.log(response);
            this.$toasted.info("Item added successfully", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.error(error);
            this.$toasted.error("Failed to add item", {
              position: "top-center",
              duration: 3000,
            });
          });
      },
      updateItem() {
        const payload = {
          agency_id: "407465",
          item_name: this.item.item_name,
          response_type: this.item.response_type,
          form_id: this.item.form_id.id,
          item_order: this.item.item_order || 0,
          is_scoring: this.item.is_scoring ? 1 : 0,
          is_multi_select: this.item.response_type === "option" ? (this.item.is_multi_select ? 1 : 0) : 0,
          depends_on_item_id: this.item.depends_on_item_id
            ? this.item.depends_on_item_id.id
            : null,
          depends_on_option_id: this.item.depends_on_option_id
            ? this.item.depends_on_option_id.id
            : null,
          quality_assurance_items_categories_id:
            this.item.quality_assurance_items_categories_id?.id,
          options: this.item.response_type === "option"
            ? this.item.options.map((opt) => ({
                id: opt.id || null,
                option_name: opt.option_name,
                score_value: opt.score_value,
                has_custom_input: opt.has_custom_input ? 1 : 0,
                custom_input_label: opt.custom_input_label || null,
                custom_input_placeholder: opt.custom_input_placeholder || null,
              }))
            : [],
        };

        this.axios
          .post(`/api/v1/auth/qa-updateItem/${this.editingItemId}`, payload)
          .then((response) => {
            this.allItems();
            this.editingItemId = null;
            this.resetItemForm();
            this.showadder = false;
            console.log(response);
            this.$toasted.info("Item updated successfully", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.error(error);
            this.$toasted.error("Failed to update item", {
              position: "top-center",
              duration: 3000,
            });
          });
      },
      deleteItem(itemId) {
        if (!confirm("Are you sure you want to delete this item?")) {
          return;
        }

        this.axios
          .delete(`/api/v1/auth/qa-deleteItem/${itemId}`)
          .then(() => {
            this.allItems();
            this.$toasted.success("Item deleted successfully", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.error(error);
            this.$toasted.error("Failed to delete item", {
              position: "top-center",
              duration: 3000,
            });
          });
      },
      clearIt() {
        this.register.date_requested = "";
        this.searchkey = "";
        this.search_result = "";
      },
      allItems() {
        this.axios
          .get(`/api/v1/auth/qa-items/407465`, {
            params: {
              form_id: this.filter.form_id || "",
            },
          })
          .then((response) => {
            this.allitems = response.data;
            this.updateOtherItems();
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      addCategory() {
        if (!this.category.form_id) {
          this.$toasted.error("Please select a form", {
            position: "top-center",
            duration: 3000,
          });
          return;
        }
        if (!this.category.category_name.trim()) {
          this.$toasted.error("Category name is required", {
            position: "top-center",
            duration: 3000,
          });
          return;
        }

        this.axios
          .post(`/api/v1/auth/qa-addCategory`, {
            form_id: this.category.form_id.id,
            category_belongs_to: "Primary",
            category_name: this.category.category_name,
            is_personnel: true,
            agency_id: "407465",
          })
          .then((response) => {
            console.log(response);
            this.category = { form_id: "", category_name: "" };
            this.$toasted.info("Category added successfully", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.error(error);
            this.$toasted.error("Failed to add category", {
              position: "top-center",
              duration: 3000,
            });
          });
      },
      addSubCategory() {
        this.axios
          .post(`/api/v1/auth/qa-addSubCategory`, {
            items_categories_id: this.subcategory.items_categories_id.id,
            sub_category_name: this.subcategory.sub_category_name,
          })
          .then((response) => {
            console.log(response);
            this.$toasted.info("Sub-category added successfully", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.error(error);
            this.$toasted.error("Failed to add sub-category", {
              position: "top-center",
              duration: 3000,
            });
          });
      },
    },
    watch: {
      "item.response_type"(type) {
        if (type === "option" && !this.item.options.length) this.addOption();
      },
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/qa-categories/407465`)
        .then((response) => {
          this.categories = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    created() {
      this.getForms();
      this.getSubCategories();
      this.allItems();
      this.getServices();
    },
  };
</script>

<style scoped>
.type-chip {
  display: inline-flex; align-items: center; gap: 5px;
  border-radius: 20px; padding: 4px 11px;
  font-size: 0.75rem; font-weight: 700; white-space: nowrap;
}
.type-chip--option { background: #eff6ff; color: #1d4ed8; }
.type-chip--text   { background: #f5f3ff; color: #6d28d9; }
.type-chip--number { background: #ecfdf5; color: #047857; }
.type-chip--date   { background: #fff7ed; color: #c2410c; }

.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  padding-bottom: 40px;
}

.header-icon-wrap {
  width: 48px; height: 48px;
  background: rgba(255,255,255,0.15);
  border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}

.tab-card { border-radius: 12px; border: 1px solid #e9ecef; }

.tab-btn { border-radius: 8px; font-weight: 500; font-size: 0.82rem; padding: 6px 14px; }

.active-tab {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border-color: transparent; color: #fff;
}

.form-card { border-radius: 12px; border: 1px solid #e9ecef; overflow: hidden; }
.table-card { border-radius: 12px; border: 1px solid #e9ecef; overflow: hidden; }

.form-card-header {
  display: flex; align-items: center; gap: 12px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
}

.section-number {
  width: 28px; height: 28px;
  background: rgba(255,255,255,0.2);
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  color: #fff; flex-shrink: 0;
}

.table-th {
  font-size: 0.73rem; text-transform: uppercase; letter-spacing: 0.04em;
  color: #64748b; font-weight: 600;
  border-bottom: 2px solid #e2e8f0; padding: 12px 16px;
}

.table-row:hover { background: #f8fafc; }

.btn-submit {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border: none; color: #fff;
  border-radius: 8px; font-weight: 600; padding: 8px 24px;
}

.btn-submit:hover { opacity: 0.9; color: #fff; }

.form-control:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 0.15rem rgba(37,99,235,0.15);
}

.checkbox-label {
  display: flex; align-items: center; gap: 6px;
  font-weight: 500; font-size: 0.85rem; color: #475569;
  margin-bottom: 0; cursor: pointer;
}

.checkbox-label input[type="checkbox"] { margin: 0; }
</style>